module.exports = __webpack_public_path__ + "static/media/gu.2ca57695.svg";